import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "icon-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#icon-colors" }),
  /*#__PURE__*/_createTextVNode(" Icon Colors ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" The inline icons can be colored using "),
  /*#__PURE__*/_createVNode("code", null, ".svg-icon-{color}"),
  /*#__PURE__*/_createTextVNode(" class that defined with "),
  /*#__PURE__*/_createVNode("code", null, "$theme-text-colors"),
  /*#__PURE__*/_createTextVNode(" variable in "),
  /*#__PURE__*/_createVNode("code", null, "sass/_variables.scss"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border d-flex flex-wrap p-10" }
const _hoisted_6 = { class: "fw-bold py-2" }
const _hoisted_7 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "d-flex flex-column flex-center w-150px me-10 mb-5"
          }, [
            _createVNode("span", {
              class: [[`svg-icon-${item}`, item === `white` && `bg-dark`], "svg-icon svg-icon-3x"]
            }, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Color-profile.svg" })
            ], 2),
            _createVNode("div", _hoisted_6, _toDisplayString(item), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_CodeHighlighter, {
        lang: "html",
        fieldHeight: 400
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<span class="svg-icon svg-icon-2x svg-icon-white"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-primary"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-secondary"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-light"><svg>...</svg></span>
        <span class="svg-icon svg-icon-2x svg-icon-success"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-info"><svg>...</svg></span>
        <span class="svg-icon svg-icon-2x svg-icon-warning"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-danger"><svg>...</svg></span>
        <span class="svg-icon svg-icon-2x svg-icon-dark"><svg>...</svg></span>
        <span class="svg-icon svg-icon-2x svg-icon-muted"><svg>...</svg></span>
        <span class="svg-icon svg-icon-2x svg-icon-gray-100"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-gray-200"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-gray-300"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-gray-400"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-gray-500"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-gray-600"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-gray-700"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-gray-800"
          ><svg>...</svg></span
        >
        <span class="svg-icon svg-icon-2x svg-icon-gray-900"
          ><svg>...</svg></span
        >`), 1)
        ]),
        _: 1
      })
    ])
  ]))
}